import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResetPasswordServiceInterface, ResetData } from './reset-password-service.interface';
import { ConfigServiceInterface } from '../../../../core/services/config/config-service.interface';
import { DataResponse, IData } from '../../../../core/responses/data.response';

@Injectable()
export class ResetPasswordService implements ResetPasswordServiceInterface {
  constructor(@Inject('ConfigServiceInterface') private configService: ConfigServiceInterface, private http: HttpClient) {}

  public confirmEmail(email: string): Observable<DataResponse> {
    return this.http.post(`${this.configService.apiUrl}/reset`, { email }).pipe(
      map((response: IData) => {
        return response.data;
      })
    );
  }

  public reset(data: ResetData): Observable<DataResponse> {
    return this.http.put(`${this.configService.apiUrl}/reset`, data).pipe(
      map((response: IData) => {
        return response.data;
      })
    );
  }
}
